import { render } from "./SlotHoverInfoComponent.vue?vue&type=template&id=6411fadd"
import script from "./SlotHoverInfoComponent.vue?vue&type=script&lang=js"
export * from "./SlotHoverInfoComponent.vue?vue&type=script&lang=js"

import "./SlotHoverInfoComponent.vue?vue&type=style&index=0&id=6411fadd&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__